import Stat from '../../stories/Stat/Stat'
import classes from './LearningComponents.module.css'

export default function LearningStats({
  xpRating,
  xpPoints,
  rank,
}: {
  xpRating: number
  xpPoints: number
  rank: number | string
}) {
  return (
    <div className={classes.learningStats}>
      <Stat title="XP Rating" value={xpRating.toFixed(2)} background="white" />
      <Stat title="XP Points" value={xpPoints} background="white" />
      <Stat title="XP Rank" value={rank} isValueSub background="white" />
    </div>
  )
}
